module.exports = "<span class=\"created-by\">\n  &copy; {{ currentYear }} NTT Data\n  Company. All Rights Reserved.\n</span>\n"